import { render, staticRenderFns } from "./dialogSearchInfoCustomer.vue?vue&type=template&id=45a71cb4"
import script from "./dialogSearchInfoCustomer.vue?vue&type=script&lang=js"
export * from "./dialogSearchInfoCustomer.vue?vue&type=script&lang=js"
import style0 from "./dialogSearchInfoCustomer.vue?vue&type=style&index=0&id=45a71cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports